import { Component } from '@angular/core';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss'],
})
export class OrganizationComponent {
  isEditMode = false;
  tabs = [
    {
      path: '/organization/users',
      label: 'Users',
      privilege: 'tenant_user/read',
    },
    {
      path: '/organization/webhooks',
      label: 'Webhooks',
      privilege: 'webhook/read',
    },
    {
      path: '/organization/apikeys',
      label: 'Api Keys',
      privilege: 'tenant_api_key/read',
    },
    {
      path: '/organization/deleted',
      label: 'Deleted Assets',
      privilege: 'asset/destroy',
    },
    {
      path: '/organization/deletedwarehouses',
      label: 'Deleted Warehouses',
      privilege: 'fixed_location/destroy',
    },
    {
      path: '/organization/deletedlocations',
      label: 'Deleted Locations',
      privilege: 'remote_location/read',
    },
    // TODO: Currently hidden, uncomment this when ready to add
    // {
    //   path: '/organization/documents',
    //   label: 'Documents',
    //   privilege: 'asset/read',
    // },
  ];
}
